import React from "react";
import { Col, Row,Tooltip } from "antd";

const AvailableToolTip = (
    <div className="dashboardTooltip">

      <p>
      This only reflects work orders created in the past 60 days.
      </p>
    </div>
  );
const Maintenance = () => {
  return (
    <div className="Maintenance">
      <div className="dshbrd_acrdn">
        <p>Work Orders</p>
        <Row>
          <Col span={12}>
              No active work orders.
          </Col>
          <Col span={12}>
              <div className="collected">
               <a href="/"><span className="widget-info-box__datum">0</span></a> 
                <h2 className="widget-info-box__description">New</h2>
              </div>
          </Col>
        </Row>

        <Row>
          <Col span={12} offset={12}>
              <div className="collected" style={{marginTop:"10px"}}>
              <a href="/"><span className="widget-info-box__datum">0</span></a> 

                <h2 className="widget-info-box__description">Assigned</h2>
              </div>
          </Col>
        </Row>
        <Row>
          <Col span={12} offset={12}>
              <div className="collected" style={{marginTop:"10px"}}>
              <a href="/"><span className="widget-info-box__datum">0</span></a> 

                <h2 className="widget-info-box__description">Estimate Requested</h2>
              </div>
          </Col>
        </Row>
        <Row>
          <Col span={12} offset={12}>
              <div className="collected" style={{marginTop:"10px"}}>
              <a href="/"><span className="widget-info-box__datum">0</span></a> 

                <h2 className="widget-info-box__description">Estimated</h2>
              </div>
          </Col>
        </Row>
        <Row>
          <Col span={12} offset={12}>
              <div className="collected" style={{marginTop:"10px"}}>
              <a href="/"><span className="widget-info-box__datum">0</span></a> 

                <h2 className="widget-info-box__description">Scheduled</h2>
              </div>
          </Col>
        </Row>
        <Row>
          <Col span={12} offset={12}>
              <div className="collected" style={{marginTop:"10px"}}>
              <a href="/"><span className="widget-info-box__datum">0</span></a> 

                <h2 className="widget-info-box__description">Waiting</h2>
              </div>
          </Col>
        </Row>
        <Row>
          <Col span={12} offset={12}>
              <div className="collected" style={{marginTop:"10px"}}>
              <a href="/"><span className="widget-info-box__datum">0</span></a> 

                <h2 className="widget-info-box__description">Completed, not billed</h2>
                <Tooltip
                placement="top"
                title={AvailableToolTip}
                trigger={["click"]}
                color={["#fff"]}
              >
                <i className="fa-sharp fa-solid fa-circle-question"></i>
              </Tooltip>
              </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Maintenance;
